export default __webpack_public_path__ + "static/media/login.be671995.svg";